module.exports = "<scatterplot></scatterplot>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/emxd-charts/scatterplot/index.html
// module id = 112
// module chunks = 0